import React from 'react'

import { useMobile } from 'hooks/ua'
import HorizonalSection from 'components/HorizonalSection'

import styles from './style.less'

import pcImg from './images/pc.png'
import mobileImg from './images/mobile.png'

export default function Intro2() {
  const isMobile = useMobile()

  return (
    <HorizonalSection
      title="闲置节点资源高效利用"
      subtitle="加入NiuLink成为资源节点，共享自有闲置网络资源，获取可靠现金收益"
    >
      <img src={isMobile ? mobileImg : pcImg} className={styles.img} />
    </HorizonalSection>
  )
}
